import { useState, useEffect } from "react";
import {
  MapPin,
  Phone,
  HardHat,
  Map,
  CheckSquare,
  Users,
  Handshake,
  Package,
  DollarSign,
  Settings,
  Calendar,
  FileText,
  Mail,
  Building,
  Pen,
  BarChart3,
  TrendingUp,
  Clock,
  Plus,
  ChevronRight,
  Filter,
  Download,
  Zap,
} from "lucide-react";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import SectionCard from "../SectionCard/SectionCard";
import StatisticCard from "../StatisticCard/StatisticCard";
import { Outlet } from "react-router-dom";
import "../Dashboard/dashboard.css";

export default function Dashboard() {
  const [searchQuery, setSearchQuery] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const [showWelcome, setShowWelcome] = useState(true);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 769);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    const timer = setTimeout(() => {
      setShowWelcome(false);
    }, 5000);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
      clearTimeout(timer);
    };
  }, []);

  const sections = [
    {
      name: "Land Management",
      icon: <Map size={24} />,
      color: "blue",
      count: 24,
      path: "/land",
    },
    {
      name: "Lead Management",
      icon: <Phone size={24} />,
      color: "purple",
      count: 18,
      path: "/leadProject",
    },
    {
      name: "Partner Management",
      icon: <HardHat size={24} />,
      color: "orange",
      count: 32,
      path: "/labour",
    },
    {
      name: "Plot Management",
      icon: <MapPin size={24} />,
      color: "red",
      count: 15,
      path: "/plot",
    },
    {
      name: "Task Management",
      icon: <CheckSquare size={24} />,
      color: "green",
      count: 47,
      path: "/task",
    },
    {
      name: "Material Management",
      icon: <Users size={24} />,
      color: "teal",
      count: 29,
      path: "/material",
    },
    {
      name: "Employee Management",
      icon: <Users size={24} />,
      color: "indigo",
      count: 36,
      path: "/getDepartment",
    },
    {
      name: "Contractor Management",
      icon: <Handshake size={24} />,
      color: "yellow",
      count: 12,
      path: "/contractor",
    },
    {
      name: "Stock Management",
      icon: <Package size={24} />,
      color: "brown",
      count: 21,
      path: "/stock",
    },
    {
      name: "Finance Management",
      icon: <DollarSign size={24} />,
      color: "emerald",
      count: 19,
      path: "/finance",
    },
    {
      name: "Machine Management",
      icon: <Settings size={24} />,
      color: "gray",
      count: 8,
      path: "/machine",
    },
    // {
    //   name: "Project Management",
    //   icon: <Calendar size={24} />,
    //   color: "cyan",
    //   count: 27,
    //   path: "/project",
    // },
    // {
    //   name: "Quotation",
    //   icon: <FileText size={24} />,
    //   color: "amber",
    //   count: 14,
    //   path: "/plotQuatation/:plotId",
    // },
    {
      name: "Letter Head",
      icon: <Mail size={24} />,
      color: "lime",
      count: 6,
      path: "/letter",
    },
    {
      name: "Office Expense",
      icon: <Building size={24} />,
      color: "pink",
      count: 11,
      path: "/office",
    },
    {
      name: "Stationary Management",
      icon: <Pen size={24} />,
      color: "violet",
      count: 9,
      path: "/stationary",
    },
  ];

  const statistics = [
    {
      title: "Total Projects",
      value: "128",
      icon: <BarChart3 size={24} />,
      change: "+12%",
      color: "blue",
    },
    {
      title: "Active Tasks",
      value: "64",
      icon: <CheckSquare size={24} />,
      change: "+8%",
      color: "green",
    },
    {
      title: "Revenue",
      value: "$48.5k",
      icon: <TrendingUp size={24} />,
      change: "+24%",
      color: "emerald",
    },
    {
      title: "Pending Tasks",
      value: "23",
      icon: <Clock size={24} />,
      change: "-5%",
      color: "amber",
      isNegative: true,
    },
  ];

  const filteredSections = sections.filter((section) =>
    section.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="dashboard">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      {isMobile && (
        <div
          className={`sidebar-overlay ${sidebarOpen ? "active" : ""}`}
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <div className="dashboard-content">
        <Header
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          showMenuButton={isMobile}
        />
        <main className="main-content">
          <Outlet context={{ filteredSections, viewMode, setViewMode }} />
        </main>
      </div>
      
    </div>
  );
}
